import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Sentry from "@sentry/react";
// import { captureConsoleIntegration } from "@sentry/integrations";
import { env as environment } from './controllers/environment';

// Sentry.init({
// 	dsn: environment.sentryDSN,
// 	integrations: [
//     Sentry.browserTracingIntegration(),
// 		captureConsoleIntegration(['error'])
// 	],

// 	// We recommend adjusting this value in production, or using tracesSampler
// 	// for finer control
// 	tracesSampleRate: 1.0,
// });
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
